const routeType = {
  COLLECT: 1,
  DROP_OFF: 2
}

export default routeType
